













import VueOptions from '@utils/VueOptions'
import SuperContainerView from '@superUI/Containers/SuperContainerView'
import SponsorOrgSelector from '@superUI/Selectors/SponsorOrgSelector'
import BrandSelector from '@superUI/Selectors/BrandSelector'
import ActivationForm from '@superUI/Forms/ActivationForm'
import RequestButton from '@components/RequestButton'

settings =
  name: "ActivationCreate"
  components: { SuperContainerView, SponsorOrgSelector, ActivationForm, RequestButton, BrandSelector }
  resources:
    newActivation:
      resourceName: 'activation'
      slug: 'activations/new'
  vue:
    data: ->
      selectedSubSponsorId: null
      selectedTopSponsorId: null
      selectedSponsorId: null

      selectedBrandId: null

    mounted: () ->
      @lookupSponsorId()
      @lookupBrandId()

    computed:
      hasSponsorOrBrandId: ->
        return true if @selectedSponsorId || @selectedBrandId

    methods:
      onSave: (item) -> @$router.push({ name: 'ActivationShowPage', params: { activationId: item.id } })

      hiSave: ->
        @prime.newActivation.sponsor_id = @selectedSponsorId
        @prime.newActivation.brand_id = @selectedBrandId if @selectedBrandId
        @saveItem('prime.newActivation')

      hiBack: ->
        if @selectedSponsorId
          @selectedSubSponsorId = null
          @selectedSponsorId = null
        else
          @selectedSubSponsorId = null
          @selectedTopSponsorId = null

      hiSponsorSelected: (selectedSponsor) ->
        @selectedSponsorId = selectedSponsor.id
      
      hiBrandSelected: (selectedBrand) ->
        @selectedBrandId = selectedBrand.id
      
      lookupSponsorId: ->
        @selectedSponsorId = @$route.params.sponsor_id if @$route.params.sponsor_id?

      lookupBrandId: ->
        @selectedBrandId = @$route.query.brandId if @$route.query.brandId?

export default VueOptions.vue settings
